import { analyticsEvents } from "@helpers/Analytics";

const { roomPageEvent, optimizelyEvent } = analyticsEvents;

const sugarcubeMessageTypes = {
  MAGIC_WINDOW_GA_TRACKING: "MAGIC_WINDOW_GA_TRACKING",
};

const sugarcubeAnalyticsActions = {
  save: "save",
  addProduct: "add_product",
};

export const handleSugarcubeEvent =
  (dispatch) =>
  ({ data = {} }) => {
    if (data.type !== sugarcubeMessageTypes.MAGIC_WINDOW_GA_TRACKING) return;

    if (process.env.GATSBY_ENV !== "production") {
      console.log("Sugarcube event:", data);
    }
    // Send raw sugarcube event
    dispatch(data.action, data.label);

    switch (data.action) {
      case sugarcubeAnalyticsActions.save:
        dispatch(roomPageEvent.action, roomPageEvent.labels.save());
        dispatch(optimizelyEvent.action, optimizelyEvent.roomPage.save);
        break;
      case sugarcubeAnalyticsActions.addProduct:
        dispatch(roomPageEvent.action, roomPageEvent.labels.placeFurniture());
        dispatch(optimizelyEvent.action, optimizelyEvent.roomPage.addProduct);
        break;

      default:
        break;
    }
  };
